export const localize_signup = {
    localize_signup_alert_confirm: "Bạn cần đồng ý với điều khoản sử dụng dịch vụ trước khi chuyển sang bước tiếp theo!"
}